import { Box, Skeleton, Tooltip, Typography } from "@mui/material";
import { ClientName } from "../Auth.styles";

type Props = {
  isLoading: boolean;
  oauthClientInfo:
    | {
        clientName: string;
        clientRedirectUrl: string;
      }
    | null
    | undefined;
  loggedIn?: boolean;
};

export const OAuthClientInfoBox = (props: Props) => {
  const { isLoading, oauthClientInfo, loggedIn } = props;
  if (!isLoading && !oauthClientInfo) return null;
  return (
    <Box>
      {isLoading && (
        <Skeleton
          height={32}
          component={Typography}
          maxWidth={"55%"}
          margin={"auto"}
        />
      )}
      {!isLoading && !!oauthClientInfo && (
        <Tooltip
          title={`Logging in will redirect you to: ${oauthClientInfo.clientRedirectUrl}`}
        >
          {loggedIn ? (
            <Typography textAlign={"center"}>
              Continue to <ClientName>{oauthClientInfo.clientName}</ClientName>?
            </Typography>
          ) : (
            <Typography mt={1} textAlign={"center"}>
              to continue to{" "}
              <ClientName>{oauthClientInfo.clientName}</ClientName>
            </Typography>
          )}
        </Tooltip>
      )}
    </Box>
  );
};
